<!-- 出入口配置 -->
<template>
  <div class="getwayConfig-page section-main__warp">
    <div class="config-list" v-if="!editType">
      <ioc-table
        ref="table"
        :data="tableData"
        :option="tableOption"
        :page="page"
        @search-change="searchResult"
        @search-reset="resetQuery"
        @current-change="selectPage"
        @size-change="changeSize"
      >
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd('add')" class="el-icon-plus">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-xiugai"
              @click="handleEdit(scope.row, 'edit')"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-shanchu"
              @click="handleDel(scope.row, scope.index)"
            ></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <div class="config-page" v-show="editType">
      <div class="page-right">
        <div class="right-car">
          <div class="page-title">
            <div class="car-title borderL">
              出入口车辆道闸
              <span class="tip" v-if="tip.carGate">*请选择设备</span>
            </div>
            <el-button
              class="el-icon-plus"
              type="info"
              @click="addDevice('carGate', '25')"
            >
              添加</el-button
            >
          </div>

          <div class="speak-content">
            <el-scrollbar>
              <div class="scroll_list">
                <div
                  @mouseenter="onMouseoverEnvDelBtn(index, 'carGate')"
                  @mouseleave="onMouseleaveEnvDelBtn(index, 'carGate')"
                  class="list_item flex-row"
                  v-for="(item, index) in carWayList"
                  :key="item.deviceId"
                >
                  <div class="item_index">{{ index + 1 }}</div>
                  <!-- <div class="item_status">
                    {{ item.inOrOut == 1 ? "入场" : "出场" }}
                  </div> -->
                  <div class="item_name">{{ item.deviceName }}</div>
                  <!-- <div class="item_icon">
                    <i class="icon iconfont-menu iconchurukouguanli"></i>
                    抬杆
                  </div> -->
                  <div class="item_del" v-if="index == carHoverIndex">
                    <i
                      @click="removeDevice('carGate', index)"
                      class="el-icon-delete"
                      style="cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
        <div class="right-person">
          <div class="page-title">
            <div class="person-title borderL">
              出入口人行闸机
              <span class="tip" v-if="tip.personGate">*请选择设备</span>
            </div>
            <el-button
              class="el-icon-plus"
              type="info"
              @click="addDevice('personGate', '22')"
            >
              添加</el-button
            >
          </div>
          <div class="speak-content">
            <el-scrollbar>
              <div class="scroll_list">
                <div
                  @mouseenter="onMouseoverEnvDelBtn(index, 'personGate')"
                  @mouseleave="onMouseleaveEnvDelBtn(index, 'personGate')"
                  class="list_item flex-row"
                  v-for="(item, index) in personWayList"
                  :key="item.deviceId"
                >
                  <div class="item_index">{{ index + 1 }}</div>
                  <!-- <div class="item_status">
                    {{ item.inOrOut == 1 ? "入场" : "出场" }}
                  </div> -->
                  <div class="item_name">{{ item.deviceName }}</div>
                  <!-- <div class="item_icon">
                    <i class="icon iconfont icon-zhaji"></i>
                    开闸
                  </div> -->
                  <div class="item_del" v-if="index == personHoverIndex">
                    <i
                      @click="removeDevice('personGate', index)"
                      class="el-icon-delete"
                      style="cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>

      <div class="page-middle">
        <!--出入口监控点-->
        <div class="middle-spot">
          <div class="borderL">
            出入口监控点 <span class="tip" v-if="tip.camera">*请选择设备</span>
          </div>
          <div class="content-btn">
            <div class="screen-num">
              <i
                class="el-icon-full-screen full-btn"
                :class="screenStatus == 'full' ? 'active' : ''"
                @click="handleDeviceClick('full')"
                title="一分屏"
              ></i>
              <i
                class="el-icon-menu four-btn"
                :class="screenStatus == 'four' ? 'active' : ''"
                @click="handleDeviceClick('four')"
                title="四分屏"
              ></i>
            </div>
            <div class="edit-btn">
              <el-button class="el-icon-plus" type="info" @click="addCamera">
                添加</el-button
              >
            </div>
          </div>
          <div
            class="ocx-box"
            v-loading="loadingzp"
            element-loading-text="视频抓拍中..."
            element-loading-spinner="el-icon-loading"
          >
            <playerBox
              ref="player"
              :isHideClose="true"
              :windowNumber="windowNumber"
              @handleLoginSuccess="handleLoginSuccess"
            ></playerBox>
          </div>
        </div>
        <!--出入口语音-->
        <div class="middle-speak">
          <div class="page-title">
            <div class="borderL">
              出入口语音对讲
              <span class="tip" v-if="tip.speak">*请选择设备</span>
            </div>
            <el-button class="el-icon-plus" type="info" @click="addDevice('speak', '26')">
              添加</el-button
            >
          </div>
          <div class="speak-content">
            <el-scrollbar>
              <div class="scroll_list">
                <div
                  @mouseenter="onMouseoverEnvDelBtn(index, 'speak')"
                  @mouseleave="onMouseleaveEnvDelBtn(index, 'speak')"
                  class="list_item flex-row"
                  v-for="(item, index) in speakList"
                  :key="item.deviceId"
                >
                  <div class="item_index">{{ index + 1 }}</div>
                  <div class="item_name">{{ item.deviceName }}（语音立柱）</div>
                  <div class="item_name">{{ item.targetDeviceName }}（监听主机）</div>
                  <!-- <div class="item_icon">
                    <i class="el-icon-microphone"></i>
                    呼叫
                  </div> -->
                  <div class="item_del" v-if="index == speakHoverIndex">
                    <i
                      @click="removeDevice('speak', index)"
                      class="el-icon-delete"
                      style="cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="page-left">
        <div>
          <div class="page-left_title borderL">出入口信息</div>
          <div class="page-left_form">
            <el-form ref="form" :model="addForm" :rules="rules" label-width="60px">
              <el-form-item label="名称" prop="sceneName">
                <el-input
                  v-model="addForm.sceneName"
                  maxlength="15"
                  placeholder="请输入名称,长度15个字符以内"
                ></el-input>
              </el-form-item>
              <el-form-item label="经度" prop="longitude">
                <div style="display: flex">
                  <el-input
                    v-model="addForm.longitude"
                    placeholder="请选择经纬度"
                    readonly
                  ></el-input>
                  <el-button
                    type="text"
                    size="small"
                    @click="openMap"
                    style="position: absolute; right: 0px; font-size: 18px; top: -3px"
                    class="iconfont icon-position choose-person"
                  ></el-button>
                </div>
              </el-form-item>
              <el-form-item label="纬度" prop="latitude">
                <div style="display: flex">
                  <el-input
                    v-model="addForm.latitude"
                    placeholder="请选择经纬度"
                    readonly
                  ></el-input>
                  <el-button
                    type="text"
                    size="small"
                    @click="openMap"
                    style="position: absolute; right: 0px; font-size: 18px; top: -3px"
                    class="iconfont icon-position choose-person"
                  ></el-button>
                </div>
              </el-form-item>
              <el-form-item label="位置">
                <el-input v-model="addForm.location"></el-input>
              </el-form-item>
            </el-form>
            <div class="form-footer">
              <el-button @click="cancel">{{
                submitLoading ? "提交中" : "取消"
              }}</el-button>
              <el-button type="primary" :loading="submitLoading" @click="configSubmit">{{
                submitLoading ? "提交中" : "确定"
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--地图取经纬度-->
    <appPanel
      class="app-panel"
      :isExpand="showMapPanel"
      @cancel="handleCloseMap"
      @screen="handleScreen"
      isScreen
      title="选择位置"
    >
      <appMap
        ref="refAppMap"
        divId="mini-map"
        @mapReady="mapReady"
        style="width: 100%; height: 100%"
      ></appMap>

      <div slot="footer">
        <el-button @click="handleCloseMap"> 取消</el-button>
        <el-button type="primary" @click="handleSaveMap">确定</el-button>
      </div>
    </appPanel>
    <!--选择出入口摄像机设备-->
    <appPanel
      class="appPanel"
      :isExpand="showCameraPanel"
      @cancel="handleCloseCamera"
      title="摄像机设备"
    >
      <div class="panel-search">
        <div style="display: flex; align-items: center">
          <span style="width: 100px">设备名称</span>
          <el-input
            placeholder="请输入设备名称"
            clearable
            v-model="deviceCamera"
          ></el-input>
        </div>
        <div>
          <el-button type="primary" @click="handelSearch">查询</el-button>
          <el-button type="info" @click="handelReset"> 重置 </el-button>
        </div>
      </div>
      <el-table
        :data="deviceData"
        ref="cameraTable"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="选择" width="85" type="selection"> </el-table-column>
        <el-table-column label="默认设备" width="100" prop="defaultDeviceId">
          <template slot-scope="scope">
            <el-radio
              v-model="defaultDeviceId"
              title="设置为默认摄像机"
              :label="scope.row.thirdDeviceId"
              :disabled="handleIsCheck(scope.row)"
              >{{ "" }}</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button
              type="text"
              class="icon iconfont-lunan icon-lunan-shipinjiankong-2"
              @click="playVideo(scope.row)"
            ></el-button>
            <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="设备位置" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="ioc-table__pagination">
        <el-pagination
          class="mt10 mb10"
          background
          :layout="'total, sizes, prev, pager, next, jumper'"
          :page-size="cameraPage.pageSize"
          :total="cameraPage.total"
          :pager-count="cameraPage.countPage || 7"
          :current-page="cameraPage.currentPage"
          @size-change="cameraSizeChange"
          @current-change="cameraPageChange"
          @prev-click="cameraPageChange"
          @next-click="cameraPageChange"
        />
      </div>

      <div slot="footer">
        <el-button @click="cancelCamera"> 取消</el-button>
        <el-button type="primary" @click="confirmCamera">确定</el-button>
      </div>
    </appPanel>
    <!-- 语音设备 -->
    <appPanel
      class="appPanel"
      :isExpand="showSpeakPanel"
      title="添加语音设备"
      @cancel="cancelSpeak"
    >
      <div class="speak-body flex-row">
        <div class="speak-body_left">
          <div class="body_title">语音立柱设备</div>
          <el-table
            ref="gateTable"
            :data="deviceData"
            style="width: 326px; height: calc(100% - 40px)"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="55">
              <template slot-scope="scope"
                ><el-radio
                  v-model="speakDevice"
                  :label="scope.row.deviceNumber"
                  @change="speakChange(scope.row)"
                  >{{ "" }}</el-radio
                ></template
              >
            </el-table-column>
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="deviceName" label="设备名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="areaName" label="设备位置" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
        <div class="speak-body_right">
          <div class="body_title">监听主机设备</div>

          <el-table
            ref="gateTable"
            :data="deviceData"
            style="width: 326px; height: calc(100% - 40px)"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="55">
              <template slot-scope="scope"
                ><el-radio
                  v-model="sourceDevice"
                  :label="scope.row.deviceNumber"
                  @change="sourceChange(scope.row)"
                  >{{ "" }}</el-radio
                >
              </template>
            </el-table-column>

            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="deviceName" label="设备名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="areaName" label="设备位置" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="cancelSpeak"> 取消</el-button>
        <el-button type="primary" @click="confirmSpeak">确定</el-button>
      </div>
    </appPanel>
    <!-- 车辆道闸，人行闸机 -->
    <appPanel
      class="appPanel"
      :isExpand="showGatePanel"
      @cancel="handleCloseGate"
      :title="type == 'carGate' ? '车辆道闸' : '人行闸机'"
    >
      <ioc-table
        ref="iocTable"
        :data="deviceData"
        :option="deviceOption"
        :page="devicePage"
        @selection-change="handleSelectionChange"
        @size-change="deviceChangeSize"
        @current-change="deviceCurrentChange"
        @search-change="deviceSearch"
        @search-reset="deviceReset"
      >
      </ioc-table>
      <div slot="footer">
        <el-button @click="cancelDevice"> 取消</el-button>
        <el-button type="primary" @click="confirmDevice">确定</el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import { tableOption } from "../config/config";
import appPanel from "@src/components/business/app-panel/index.vue";
import utils from "@src/common/utils";
import { getwayControl } from "../api";
import appMap from "@src/components/common/gis/index";
import playerBox from "../components/player-box.vue";

export default {
  data() {
    return {
      tip: {
        camera: false,
        speak: false,
        carGate: false,
        personGate: false,
      },
      submitLoading: false,
      editType: "",
      addForm: {
        deviceSceneDetailList: [],
        sceneType: 1,
        longitude: "",
        latitude: "",
        location: "",
      },
      rules: {
        sceneName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["change"],
          },
        ],
        longitude: [
          {
            required: true,
            message: "请选择经纬度",
            trigger: ["change"],
          },
        ],
        latitude: [
          {
            required: true,
            message: "请选择经纬度",
            trigger: ["blur", "change"],
          },
        ],
      },
      tableData: [],
      deviceCamera: "",
      cameraPage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },

      tableOption: tableOption(this),
      showMapPanel: false,
      speakList: [],
      speakDevice: "",
      speakObj: {},
      sourceObj: {},
      sourceDevice: "",
      sourceList: [],
      cameraList: [],
      personWayList: [],
      carWayList: [],
      speakHoverIndex: null,
      carHoverIndex: null,
      personHoverIndex: null,
      showCameraPanel: false,
      isCar: false,
      showGatePanel: false,
      showSpeakPanel: false,
      searchParams: {
        sceneName: "",
        location: "",
      },
      deviceData: [],
      deviceParams: {},
      devicePage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceOption: {
        index: true,
        selection: true,
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            align: "center",
            search: true,
            clearable: true,
          },
          {
            label: "设备位置",
            prop: "areaName",
            align: "center",
          },
        ],
      },
      selectedData: [],
      type: "",
      addPointId: "addPointId",
      tempPointList: [],
      cameraName: "",
      screenStatus: "four",
      sceneCode: "",
      windowNumber: 4,
      loadingzp: false,
      selectedDevice: [],
      defaultDeviceId: "",
    };
  },
  components: {
    appPanel,
    appMap,
    playerBox,
  },
  watch: {
    windowNumber: {
      handler(newValue) {
        if (this.$refs.player) {
          this.$refs.player.windowNumber = newValue;
        }
      },
      immediate: true,
    },
  },
  computed() {},

  beforeDestroy() {
    this.$refs.refAppMap.destroyLocation();
  },
  mounted() {
    this.queryScenceList();
  },

  methods: {
    handleScreen() {
      this.$refs.refAppMap.refreshMap();
    },
    //摄像机修改or查询默认选中
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.cameraTable.toggleRowSelection(row);
          this.$forceUpdate();
        });
      } else {
        this.$refs.cameraTable.clearSelection();
      }
    },
    handleDeviceClick(data) {
      this.screenStatus = data;
      data == "full" ? (this.windowNumber = 1) : (this.windowNumber = 4);
    },
    //单窗口播放实况
    playVideo(data) {
      this.$app.AppInstance.handleMiniPlay({
        playType: "live",
        playTitle: data.thirdDeviceName, //摄像机名称
        playId: data.thirdDeviceId, //摄像机id
      });
    },
    mapReady() {
      this.$refs.refAppMap.addClickEvent(this.addHandleMapClick);
    },
    addHandleMapClick(e) {
      console.log(e);
      //   if (!this.openPanel || this.panelType == 2 || this.panelType == 3) {
      //     return;
      //   }
      //经纬度打点
      let markerArray = [
        {
          coord: [e[0], e[1]],
          anchor: [10, 25],
          scale: 1,
          src: "/images/theme/newDark/map/position_red.png",
        },
      ];
      this.tempPointList = [...markerArray];
      this.$refs.refAppMap.addMarket(markerArray, this.addPointId);
    },
    // 配置list
    queryScenceList() {
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        sceneName: this.searchParams.sceneName,
        location: this.searchParams.location,
      };
      this.$fetch(getwayControl.queryDeviceSceneList, params).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    searchResult(params) {
      this.searchParams = params;
      this.queryScenceList();
    },
    resetQuery() {
      this.queryScenceList();
    },
    selectPage(pageNum) {
      this.page.pageNum = pageNum;
      this.queryScenceList();
    },
    changeSize(size) {
      this.page.pageSize = size;
      this.queryScenceList();
    },
    // 设备list
    deviceChangeSize(size) {
      this.devicePage.pageSize = size;
      this.addDevice(this.type, this.deviceType);
    },
    deviceCurrentChange(pageNum) {
      this.devicePage.pageNum = pageNum;
      this.addDevice(this.type, this.deviceType);
    },
    deviceSearch(params) {
      this.deviceParams = params;
      this.addDevice(this.type, this.deviceType);
    },
    deviceReset() {
      this.deviceParams = {};
      this.addDevice(this.type, this.deviceType);
    },

    handleEdit(data, type) {
      this.editType = type;
      this.handleDetail(data.sceneCode);
      this.sceneCode = data.sceneCode;
    },
    handleAdd(type) {
      this.editType = type;
      this.defaultDeviceId = "";
      this.windowNumber = 4;
    },
    handleLoginSuccess() {
      console.log("cjheng1");
    },
    handleDetail(code) {
      this.$fetch(getwayControl.queryDeviceSceneDetail, {
        sceneCode: code,
      }).then((res) => {
        if (res.success) {
          this.addForm = res.returnObj;
          this.cameraList = this.addForm.deviceSceneDetailList.filter((item) => {
            return item.deviceMark == "18";
          });
          this.defaultDeviceId = this.addForm.defaultDeviceSceneDetail.thirdDeviceId;
          this.cameraList.forEach((el, index) => {
            this.$refs.player.handlePlayLive(
              {
                thirdCameraId: el.thirdDeviceId,
                name: el.deviceName,
              },
              index + 1
            );
          });

          this.personWayList = this.addForm.deviceSceneDetailList.filter((item) => {
            return item.deviceMark == "22";
          });
          this.carWayList = this.addForm.deviceSceneDetailList.filter((item) => {
            return item.deviceMark == "25";
          });
          this.speakList = this.addForm.deviceSceneDetailList.filter((item) => {
            return item.deviceMark == "26";
          });
          this.sourceList = this.addForm.deviceSceneDetailList.filter((item) => {
            return item.deviceMark == "26";
          });
        }
      });
    },
    handleDel(data) {
      this.$confirm("您确定删除该出入口配置吗？", "删除确认", {
        type: "warning",
      }).then(() => {
        this.$fetch(getwayControl.deleteDeviceScene, {
          sceneCode: data.sceneCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功！");
            this.queryScenceList();
          }
        });
      });
    },
    configSubmit() {
      // let liveVideo = this.$refs.player.deviceRecord; //正在播放的视频信息
      // let liveList = [];
      // for (let key in liveVideo) {
      //   liveList.push(this.cameraList[key.split("_")[1] - 1]);
      // }
      // this.cameraList = liveList;
      // camera: false,
      // speak: false,
      // carGate: false,
      // personGate: false,
      // if (this.carWayList.length == 0) {
      //   this.tip.carGate = true;
      // }
      // if (this.personWayList.length == 0) {
      //   this.tip.personGate = true;
      // }
      if (this.speakList.length == 0) {
        this.tip.speak = true;
      }
      if (this.cameraList.length == 0) {
        this.tip.camera = true;
      }
      // this.carWayList.length *this.personWayList.length *
      if (this.speakList.length * this.cameraList.length == 0) {
        return;
      }
      this.$refs.form.validate((res) => {
        if (!res) {
          return;
        }
        this.submitLoading = true;
        let temArr = [];
        let api = getwayControl.addDeviceScene;
        let params = {};
        let cameraArr = [];
        if (this.editType == "edit") {
          params.sceneCode = this.sceneCode;
          api = getwayControl.updateDeviceScene;
        }
        // else {
        temArr = this.speakList.concat(this.carWayList, this.personWayList);
        cameraArr = this.cameraList.map((item, index) => {
          let defaultShow = "";
          item.thirdDeviceId == this.defaultDeviceId
            ? (defaultShow = "1")
            : (defaultShow = "0");
          return {
            deviceMark: item.deviceType || item.deviceMark,
            deviceId: item.deviceId,
            deviceName: item.deviceName,
            thirdDeviceId: item.thirdDeviceId,
            // sort: index,
            defaultShow: defaultShow,
          };
        });
        this.addForm.deviceSceneDetailList = temArr.map((item, index) => {
          console.log(item, "===item");
          return {
            deviceMark: item.deviceType || item.deviceMark,
            deviceId: item.deviceId,
            deviceName: item.deviceName,
            thirdDeviceId: item.thirdDeviceId,
            sort: index,
            targetDeviceName: item.targetDeviceName ? item.targetDeviceName : "",
            targetDeviceId: item.targetDeviceId ? item.targetDeviceId : "",
          };
        });
        this.addForm.deviceSceneDetailList = this.addForm.deviceSceneDetailList.concat(
          cameraArr
        );
        // }
        params.deviceSceneDetailList = this.addForm.deviceSceneDetailList;
        params.sceneName = this.addForm.sceneName;
        params.sceneType = "1";
        params.latitude = this.addForm.latitude;
        params.longitude = this.addForm.longitude;
        params.location = this.addForm.location;
        this.$fetch(api, params).then((res) => {
          this.submitLoading = false;
          if (res.success) {
            this.$message.success(
              this.editType == "edit" ? "出入口配置修改成功！" : "出入口配置新增成功！"
            );
            this.cancel();
            this.queryScenceList();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    cancel() {
      this.editType = "";
      this.speakList = [];
      this.carWayList = [];
      this.cameraList = [];
      this.personWayList = [];
      for (let key in this.tip) {
        this.tip[key] = false;
      }
      this.addForm = this.$options.data().addForm;
      this.$refs.form.resetFields();
      if (this.$refs.player.deviceRecord) {
        this.$refs.player.handleStopAllVideo();
      }
    },
    //打开地图
    openMap() {
      if (this.addForm.longitude && this.addForm.latitude) {
        this.addHandleMapClick([this.addForm.longitude, this.addForm.latitude]);
      }
      this.showMapPanel = true;
    },
    handleCloseMap() {
      this.showMapPanel = false;
      this.tempPointList = [];
      this.$refs.refAppMap.clearLayer(this.addPointId);
    },
    handleSaveMap() {
      this.addForm.longitude = this.tempPointList[0].coord[0];
      this.addForm.latitude = this.tempPointList[0].coord[1];
      this.handleCloseMap();
    },
    handleCloseGate() {
      this.showGatePanel = false;
      this.$refs.iocTable.$refs["search-form"].resetFields();
      this.deviceParams = {};
      this.devicePage.pageSize = 10;
      this.devicePage.pageNum = 1;
      this.devicePage.total = 0;
      this.selectedData = [];
      this.deviceData = [];
      // this.speakList = [];
      // this.carWayList = [];
      // this.cameraList = [];
      // this.personWayList = [];
    },
    //语音悬停
    onMouseoverEnvDelBtn(index, type) {
      type == "speak"
        ? (this.speakHoverIndex = index)
        : type == "carGate"
        ? (this.carHoverIndex = index)
        : (this.personHoverIndex = index);
    },
    onMouseleaveEnvDelBtn(index, type) {
      this.speakHoverIndex = null;
      this.carHoverIndex = null;
      this.personHoverIndex = null;
    },
    addCamera() {
      this.deviceCamera = "";
      this.showCameraPanel = true;
      this.type = "camera";
      // this.editType !== "edit" ? (this.defaultDeviceId = "") : "";
      // this.defaultDeviceId="f86cca12-ed14-4ece-8167-246add97a8ea"
      // let liveVideo = this.$refs.player.deviceRecord; //正在播放的视频信息
      // let liveList = [];
      // for (let key in liveVideo) {
      //   liveList.push(this.cameraList[key.split("_")[1] - 1]);
      // }
      // this.cameraList = liveList;
      this.handelSearch();
    },
    addDevice(type, deviceType) {
      console.log(type, "type");
      this.type = type;
      this.deviceType = deviceType;

      type == "speak" ? (this.showSpeakPanel = true) : (this.showGatePanel = true);
      this.getDeviceList(deviceType).then((res) => {
        res.forEach((item, index) => {
          let deviceArr = [];
          type == "carGate"
            ? (deviceArr = this.carWayList)
            : type == "personGate"
            ? (deviceArr = this.personWayList)
            : (deviceArr = this.speakList);
          deviceArr.forEach((el) => {
            if (el.thirdDeviceId == item.thirdDeviceId) {
              this.$refs.gateTable.toggleRowSelection(item);
              // this.selectedDevice.push(item);
            }
          });
        });
        // console.log(this.selectedDevice, "===this.selectedDevice");
        this.$forceUpdate();
      });
    },

    //删设备
    removeDevice(type, index) {
      // console.log(type, "index");
      if (type == "speak") {
        this.speakList.splice(index, 1);
        this.tip.speak = this.speakList.length == 0 ? true : false;
      } else if (type == "carGate") {
        this.carWayList.splice(index, 1);
        // this.tip.carGate = this.carWayList.length == 0 ? true : false;
      } else if (type == "personGate") {
        this.personWayList.splice(index, 1);
        // this.tip.personGate = this.personWayList.length == 0 ? true : false;
      }
      console.log(this.carWayList);
      console.log(this.personWayList);
      console.log(this.speakList);
    },
    handleCloseCamera() {
      this.showCameraPanel = false;
      this.cameraPage.pageSize = 10;
      this.cameraPage.pageNum = 1;
    },
    // 选择立柱
    speakChange(data) {
      this.speakObj = {
        deviceName: data.deviceName,
        deviceId: data.deviceId,
        deviceType: data.deviceType,
        thirdDeviceId: data.thirdDeviceId,
      };
    },
    // 选择主机
    sourceChange(data) {
      this.sourceObj = {
        targetDeviceName: data.deviceName,
        targetDeviceId: data.deviceId,
      };
    },
    cancelCamera() {
      this.handleCloseCamera();
    },
    confirmCamera() {
      this.cameraList = this.selectedData;
      if (this.cameraList.length == 0) {
        this.$message.warning("请至少选择一个摄像机");
        return;
      }
      if (this.cameraList.length > 4) {
        this.$message.warning("最多选择四个摄像机设备");
        return;
      }

      if (!this.defaultDeviceId) {
        this.$message.warning("请设置默认摄像机");
        return;
      }
      if (
        !this.cameraList.some((el) => {
          return el.thirdDeviceId == this.defaultDeviceId;
        })
      ) {
        this.$message.warning("请重新设置默认摄像机");
        return;
      }
      this.$refs.player.handleStopAllVideo();

      if (this.cameraList.length > this.windowNumber) {
        this.handleDeviceClick("four");
      }

      setTimeout(() => {
        this.cameraList.forEach((item, index) => {
          this.$refs.player.handlePlayLive(
            {
              thirdCameraId: item.thirdDeviceId,
              name: item.thirdDeviceName,
            },
            index + 1
          );
        });
      }, 200);
      this.handleCloseCamera();
    },
    cancelDevice() {
      this.handleCloseGate();
    },
    //选中设备
    handleSelectionChange(data) {
      console.log(data);
      this.selectedData = data;
    },
    handleIsCheck(row) {
      let isCheck = !this.selectedData.some((el) => {
        return el.deviceId == row.deviceId;
      });
      // if (isCheck) {
      //   if (row.thirdDeviceId == this.defaultDeviceId) {
      //     this.defaultDeviceId = "";
      //   }
      // }
      return isCheck;
    },
    // 语音设备
    cancelSpeak() {
      this.showSpeakPanel = false;
      this.sourceObj = {};
      this.speakObj = {};
      this.sourceDevice = "";
      this.speakDevice = "";
    },
    confirmSpeak() {
      let obj = { ...this.sourceObj, ...this.speakObj };
      if (!this.speakObj.deviceId) {
        this.$message.warning("请选择语音立柱");
        return;
      } else if (!this.sourceObj.targetDeviceId) {
        this.$message.warning("请选择监听主机");
        return;
      } else {
        this.speakList.push(obj);
        this.tip.speak = false;
        this.cancelSpeak();
      }
    },
    confirmDevice() {
      if (this.type == "speak") {
        if (this.selectedData.length > 3) {
          this.$message.warning("最多添加三个语音对讲设备!");
          return;
        }

        this.speakList = this.selectedData.map((el) => {
          return el;
        });
      } else if (this.type == "source") {
        if (this.selectedData.length > 3) {
          this.$message.warning("最多添加三个语音对讲设备!");
          return;
        }
        this.sourceList = this.selectedData.map((el) => {
          return el;
        });
      } else if (this.type == "carGate") {
        if (this.selectedData.length > 4) {
          this.$message.warning("最多添加四个车辆道闸!");
          return;
        }
        this.carWayList = this.selectedData.map((el) => {
          return el;
        });
      } else {
        if (this.selectedData.length > 6) {
          this.$message.warning("最多添加六个人行道闸!");
          return;
        }
        this.personWayList = this.selectedData.map((el) => {
          return el;
        });
      }
      this.tip[this.type] = false;
      this.cancelDevice();
    },
    getDeviceList(type) {
      return new Promise((resolve) => {
        this.$fetch(getwayControl.getDeviceListByPage, {
          // 道闸25
          deviceType: type ? type : 25,
          page: this.devicePage.pageNum,
          pageSize: type == 26 ? 500 : this.devicePage.pageSize,
          ...this.deviceParams,
        }).then((res) => {
          if (res.success) {
            this.deviceData = res.returnObj.list;
            this.devicePage.total = res.returnObj.total;
            resolve(this.deviceData);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    handelSearch() {
      this.getDeviceCameraList("18").then((res) => {
        let checkList = [];
        res.forEach((item, index) => {
          this.cameraList.forEach((el) => {
            if (el.thirdDeviceId == item.thirdDeviceId) {
              checkList.push(item);
            }
          });
        });
        this.toggleSelection(checkList);
      });
    },
    handelReset() {
      this.deviceCamera = "";
      this.handelSearch();
    },
    cameraSizeChange(size) {
      this.cameraPage.pageSize = size;
      this.handelSearch();
    },
    cameraPageChange(pageNum) {
      this.cameraPage.pageNum = pageNum;
      this.handelSearch();
    },
    getDeviceCameraList(type) {
      return new Promise((resolve) => {
        this.$fetch(getwayControl.getDeviceListByPage, {
          deviceType: type,
          page: this.cameraPage.pageNum,
          pageSize: this.cameraPage.pageSize,
          deviceName: this.deviceCamera,
        }).then((res) => {
          if (res.success) {
            this.deviceData = res.returnObj.list;
            this.cameraPage.total = res.returnObj.total;
            resolve(this.deviceData);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
.app-side-panel__header {
  .title {
    padding: 0px 6px;
    border-left: 4px solid #407aee;
    margin-left: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.appPanel {
  z-index: 3;
}
:deep .el-table__body-wrapper {
  width: 100%;
  height: calc(100% - 130px);
  max-height: calc(100% -130px);
  overflow-y: auto;
  @include set_theme_color(background-color, left-menu-bg-color);
}
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
}
.panel-search {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.ocx-box {
  flex: 1;
  padding: 12px 0px 0;
  // margin: 12px 2px;
}
//语音设备面板
.speak-body {
  width: 100%;
  height: 100%;
  position: relative;
  :deep .el-table__body-wrapper {
    width: 100%;
    height: calc(100% - 40px);
    max-height: calc(100% -130px);
    overflow-y: auto;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  .body_title {
    padding: 11px 0;
    font-size: 14px;
    text-align: center;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  &_left {
    // width: 50%;
    flex: 1;
    margin-right: 16px;
  }
  &_right {
    flex: 1;
    // width: 50%;
  }
}
.config-list {
  width: 100%;
}
.active {
  background: #407aee;
}
// .camera-panel {
// }
.borderL {
  border-left: 4px solid #407aee;
  padding-left: 12px;
  font-weight: bold;
}
.config-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .scroll_list {
    padding: 10px;
  }
  .list_item {
    padding: 10px;
    border-bottom: 1px solid rgba(59, 66, 83, 1);
    &:hover {
      background: rgba(59, 66, 83, 0.65);
    }
    .item_name {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .item_name,
    .item_status {
      padding-left: 12px;
    }
    .item_icon {
      position: absolute;
      right: 15%;
    }
    .item_del {
      position: absolute;
      right: 12px;
    }
  }
  .add-btn {
    border-bottom: 1px solid rgba(59, 66, 83, 1);
    .list_left,
    .list_right {
      cursor: pointer;
      padding: 10px;
      color: #cccccc;
    }
  }
  .list_add {
    cursor: pointer;
    padding: 10px;
    color: #cccccc;
    border-bottom: 1px solid rgba(59, 66, 83, 1);
  }
  //配置左侧新增
  .page-left {
    border-radius: 5px;
    width: 340px;
    height: 100%;
    padding: 12px;
    position: relative;
    @include set_theme_color(background-color, left-menu-bg-color);
    .page-left_form {
      padding: 6px;
      margin-top: 10px;
    }
    .form-footer {
      position: absolute;
      bottom: 20px;
      width: 100%;
      text-align: center;
    }
  }
  .page-middle {
    height: 100%;
    margin: 0 8px;
    // margin-left: 16px;
    position: relative;
    flex: 1;
    // width: 54%;
    display: flex;
    flex-direction: column;
    .middle-spot {
      padding: 12px;
      @include set_theme_color(background-color, left-menu-bg-color);
      border-radius: 5px;
      width: 100%;
      height: 65%;
      display: flex;
      flex-direction: column;
    }
    .full-btn,
    .four-btn {
      padding: 5px 20px;
      font-size: 17px;
      border: 1px solid #4b5566;
      // color: #cccccc;
      cursor: pointer;
    }
    .full-btn {
      border-radius: 5px 0 0 5px;
      //   border-right: none;
    }
    .four-btn {
      border-radius: 0 5px 5px 0;
      border-left: none;
    }
    .middle-speak {
      margin-top: 8px;
      padding: 20px 10px;
      @include set_theme_color(background-color, left-menu-bg-color);
      border-radius: 5px;
      width: 100%;
      height: 35%;
      .speak-content {
        margin-top: 10px;

        .list_item:hover,
        .list_add:hover {
          background: rgba(59, 66, 83, 0.65);
        }
      }
    }

    .content-btn {
      width: 100%;
      margin-top: 16px;
      display: inline-flex;
      justify-content: space-between;
    }
  }
  //右侧道闸
  .page-right {
    height: 100%;
    width: 340px;
    display: flex;
    flex-direction: column;

    .right-car,
    .right-person {
      padding: 12px;
      @include set_theme_color(background-color, left-menu-bg-color);
      border-radius: 5px;
      width: 100%;
      // height: 48%;
      flex: 1;
    }
    .right-person {
      margin-top: 8px;
    }
  }
}
</style>
